import React from "react";

const ItensPage = ({perPage, setPerPage}) => {
    return (
        <>
            <div className="filter-itens-page">
                <select name="itens-page" value={perPage} onChange={e => setPerPage(e.target.value)}>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>
                <p className="text-itens-page">itens/página</p>
            </div>
        </>
    );
}

export default ItensPage